import { useLayoutEffect, useState } from "react";
import * as ReactDOM from "react-dom";

const Portal = ({ children, wrapperId = "portal-container" }) => {
  const [wrapperElement, setWrapperElement] = useState(null);

  const createWrapperAndAppendToBody = (wrapperId) => {
    const wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
  };

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;

    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId);
    }
    setWrapperElement(element);

    return () => {
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  if (wrapperElement === null) return null;

  return ReactDOM.createPortal(children, wrapperElement);
};

export default Portal;
